import * as React from "react";
import CountDown from "../CountDown";
import { SingleCardWrap } from "../styles.card";
import { ProductCardProps } from "./index";

import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid1 } from "../../../LayerUI/ProductInfoViews";
import { ProductImageTagViews } from "../../../LayerUI/ImageTagViews";
import { transformAParam } from "utils/browser";
import { LinkTargetType } from "../../../../services/playground";

const SingleCard = (props: ProductCardProps) => {
	const {
		productElement,
		columnNum,
		layoutStyle,
		placeholderBg,
		qnParams = {},
		isInApp,
		collectOptions = {},
		stylesForCard = { width: "7.5rem", height: "7.5rem" },
		poolId,
	} = props;
	const collect = productElement.extra?.collect;
	const titleIcon = productElement.extra?.titleIcon?.img;
	const topRightTag = productElement.extra?.imgOnTopRight;
	const topLeftTag = productElement.extra?.imgOnTopLeft;
	const bottomLeftTag = productElement.extra?.imgOnBottomLeft;
	const shipIn24hours = productElement.extra?.shipIn24hours;
	const flash = productElement.extra?.flash;
	const aProps = transformAParam({
		isInApp: !!isInApp,
		link: productElement.url,
		aTarget: LinkTargetType.Blank,
		onClick: props.onClick,
	});

	return (
		<SingleCardWrap
			{...aProps}
			style={{ height: stylesForCard?.height || "auto" }}
			id={`${poolId}${productElement.gpid}`}
		>
			<BannerContainer
				banner={{
					img: productElement.img,
					link: productElement.url,
				}}
				style={{
					position: "relative",
					flex: "0 0 auto",
					...stylesForCard,
				}}
				placeholderBg={placeholderBg}
				qnParams={{ ...qnParams }}
				keepSize={true}
				gridHeight="100%"
			>
				<ProductImageTagViews
					columnNum={1}
					rightTopTag={topRightTag}
					leftTopTag={topLeftTag}
					leftBottomTag={bottomLeftTag}
				/>

				{flash?.countdownToEnd && <CountDown countInfo={flash} needIcon={false} />}
			</BannerContainer>

			<ProductInfoGrid1
				columnNum={columnNum || 1}
				price={productElement.price}
				originalPrice={productElement.originPrice}
				pricenum={productElement.pricenum}
				originpricenum={productElement.originpricenum}
				name={productElement.name}
				titleIcon={titleIcon}
				collect={collect}
				collectOptions={collectOptions}
				shipIn24hours={shipIn24hours}
				actTags={productElement.extra.actTags}
				layoutStyle={layoutStyle}
			/>
		</SingleCardWrap>
	);
};
export default SingleCard;
